import {Stack, Typography, styled, css, alpha, IconButton} from '@mui/material';
import {Loading} from 'presentation/components/Loading/Loading';

const Container = styled(Stack)<{$isOnDrop?: boolean; $isError?: boolean}>`
	padding: 16px;
	width: 100%;
	cursor: grab;
	background-color: ${({theme, $isOnDrop}) =>
		$isOnDrop
			? theme.colors.light.primary['08Percent']
			: theme.colors.brand.primary.white} !important;
	border-radius: 4px;
	border: 1px dashed
		${({theme, $isOnDrop}) =>
			$isOnDrop ? theme.palette.primary.light : theme.colors.light.other.border};

	${({theme, $isError}) =>
		$isError &&
		css`
			border: 1px solid ${theme.colors.light.error.main};
			background-color: ${alpha(
				theme.palette.error.shades['4p'] ?? theme.palette.error.main,
				0.04,
			)} !important;
		`}
`;

const Label = styled(Typography)`
	text-align: center;
	color: ${({theme}) => theme.colors.light.primary.main};
	border-bottom: 1px solid ${({theme}) => theme.colors.light.primary.main};
	cursor: pointer;
`;

const FileInput = styled('input')`
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	z-index: -1;
`;

const StyledLoading = styled(Loading)`
	background-color: ${({theme}) => alpha(theme.palette.primary.main, 0.12)};
	border-radius: 50%;
	padding: 8px;
	gap: 8px;
`;

const ZoomButton = styled(IconButton)`
	position: absolute;
	bottom: 20px;
	right: 20px;
	background: #ffffff80;
	color: ${({theme}) => theme.palette.primary.main};
	width: 32px;
	height: 32px;
	opacity: 0.8;
	border-radius: 8px;

	svg {
		min-width: 24px;
		min-height: 24px;
	}

	&:hover {
		background: #ffffffcc;
	}

	${({theme}) => theme.breakpoints.down('sm')} {
		transform: rotate(-90deg);
		top: 20px;
	}
`;

const PreviewWrapper = styled('div')`
	display: flex;
	align-items: center;
	width: 100%;
	padding: 16px;
`;

export {Container, Label, FileInput, StyledLoading, ZoomButton, PreviewWrapper};
